import { render, staticRenderFns } from "./UserControls.vue?vue&type=template&id=4939d4c2&"
import script from "./UserControls.vue?vue&type=script&lang=js&"
export * from "./UserControls.vue?vue&type=script&lang=js&"
import style0 from "./UserControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports